import { makeStyles, Typography, Grid } from '@material-ui/core';
import { Link, Email, Language, LocationOn, Phone } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles((theme) => ({
    communication: {
        marginTop: 9,
        marginRight: 8,
        marginBottom: -9,
        color: theme.palette.primary.main,
    },
    small: {
        width: theme.spacing(33),
        height: theme.spacing(44),
    },
    smallMelas: {
        width: theme.spacing(35),
        height: theme.spacing(27),
    },
}));

export const ForeisEn = ({ activeDescription }: { activeDescription: number }) => {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Typography variant='h5'>Partners</Typography>
            <ul>
                <li>
                    <Typography align='justify'>
                        DEPARTMENT OF PHARMACOGNOSY AND NATURAL PRODUCTS CHEMISTRY (DPNPC), FACULTY OF PHARMACY NKUA
                         <a color='primary' target='_blank' href='http://en.pharm.uoa.gr/personnel/faculty-members/pharmacognosy-chemistry-of-natural-products.html'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        STABLE ISOTOPE UNIT (SIU), INSTITUTE OF NANOSCIENCE AND NANOTECHNOLOGY (INN), NCSR “DEMOKRITOS” 
                        <a color='primary' target='_blank' href='http://www.demokritos.gr/institute/institute-of-nanoscience-and-nanotechnology/'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        CENTRE FOR RESEARCH AND TECHNOLOGY HELLAS, CERTH 
                        <a color='primary' target='_blank' href='https://www.certh.gr/root.en.aspx'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        LABORATORY OF FOOD CHEMISTRY, DEPARTMENT OF CHEMISTRY, NKUA
                        <a color='primary' target='_blank' href='http://www.chem.uoa.gr/?page_id=53747&lang=en'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        LABORATORY OF DAIRY RESEARCH, THE DEPARTMENT OF FOOD SCIENCE & HUMAN NUTRITION, AUA
                        <a color='primary' target='_blank' href='http://fst.aua.gr/en'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        MELAS- EPIDAURUS OLIVE OIL DOMAIN
                        <a color='primary' target='_blank' href='https://www.melasoil.gr/en/olive-oil-factory'><Link /></a> 
                    </Typography>
                </li>

                <li>
                    <Typography align='justify'>
                        BIOHELLAS
                        <a color='primary' target='_blank' href='http://www.bio-hellas.gr/'><Link /></a> 
                    </Typography>
                </li>
            </ul>

        </React.Fragment>
    )
}